// extracted by mini-css-extract-plugin
module.exports = {"modal":"wn_bz","overlay":"wn_t7","content":"wn_t5"};